import { Question } from '../data/quizData';

interface QuizQuestionProps {
  question: Question;
  questionNumber: number;
  totalQuestions: number;
  onAnswer: (answer: string) => void;
  onBack: () => void;
  canGoBack: boolean;
}

export default function QuizQuestion({
  question,
  questionNumber,
  totalQuestions,
  onAnswer,
  onBack,
  canGoBack
}: QuizQuestionProps) {
  const progress = (questionNumber / totalQuestions) * 100;

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
      {/* Progress Bar */}
      <div className="bg-gray-100 h-2">
        <div
          className="bg-accent-500 h-full transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <div className="p-8 md:p-12">
        {/* Question Counter */}
        <div className="text-center mb-6">
          <span className="inline-block px-4 py-2 bg-secondary-100 text-secondary-700 rounded-full text-sm font-semibold">
            Pregunta {questionNumber} de {totalQuestions}
          </span>
        </div>

        {/* Question Icon & Text */}
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-accent-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className={`${question.icon} text-accent-600 text-3xl`}></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {question.question}
          </h2>
        </div>

        {/* Options */}
        <div className="grid gap-4 mb-8 max-w-2xl mx-auto">
          {question.options.map((option, index) => (
            <button
              key={index}
              onClick={() => onAnswer(option.value)}
              className="w-full text-left p-5 rounded-xl border-2 border-gray-200 hover:border-accent-500 hover:bg-accent-50 transition-all cursor-pointer group"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-gray-100 group-hover:bg-accent-500 rounded-full flex items-center justify-center flex-shrink-0 transition-colors">
                  <span className="text-gray-600 group-hover:text-white font-semibold transition-colors">
                    {String.fromCharCode(65 + index)}
                  </span>
                </div>
                <span className="text-base md:text-lg font-medium text-gray-800 group-hover:text-accent-700 transition-colors">
                  {option.text}
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex justify-center">
          {canGoBack && (
            <button
              onClick={onBack}
              className="inline-flex items-center justify-center rounded-full bg-gray-200 px-6 py-3 text-base font-semibold text-gray-700 hover:bg-gray-300 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2 text-lg"></i>
              Atrás
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
